import { render, staticRenderFns } from "./ReletPostpone.vue?vue&type=template&id=78fcb272&scoped=true"
import script from "./ReletPostpone.vue?vue&type=script&lang=js"
export * from "./ReletPostpone.vue?vue&type=script&lang=js"
import style0 from "./ReletPostpone.vue?vue&type=style&index=0&id=78fcb272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fcb272",
  null
  
)

export default component.exports